/* Native horizontal scrolling; card galleries keep their own controls. */
if (!customElements.get('tn-product-shelf')) {
  customElements.define('tn-product-shelf', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-shelf-track]');
      this.controls = this.querySelector('[data-shelf-controls]');
      this.previous = this.querySelector('[data-shelf-prev]');
      this.next = this.querySelector('[data-shelf-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      for (const item of this.track.children) this.observer.observe(item);
      this.update();
    }
    update() {
      const overflow = this.track.clientWidth > 0 && this.track.scrollWidth - this.track.clientWidth > 2;
      this.controls.hidden = !overflow;
      this.track.tabIndex = overflow ? 0 : -1;
      const position = Math.abs(this.track.scrollLeft);
      this.previous.disabled = !overflow || position <= 2;
      this.next.disabled = !overflow || position >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    move(direction) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      if (!step) return;
      const visible = Math.max(1, Math.round((this.track.clientWidth + gap) / step));
      this.track.scrollBy({ left:direction * visible * step * (style.direction === 'rtl' ? -1 : 1), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
